import React from "react";

import ModalMotion, { AnimateDirection } from "@/components/Molecules/Modal";
import DownloadPDFForm from "./DownloadPDFForm";
import useDownloadPDFForm from "./DownloadPDFForm/useDownloadPDFForm";
import DownloadPDFSuccess from "./DownloadPDFSuccess";

import { classNameGenerator } from "@/utils";

import styles from "./DownloadPDFModal.module.scss";

interface DownloadPDFModalProps {
  title: string;
  description: string;
  onClose: () => void;
  campaignSlug: string;
}

const DownloadPDFModal: React.FC<DownloadPDFModalProps> = ({
  title,
  description,
  onClose,
  campaignSlug,
}) => {
  const cls = classNameGenerator(styles);

  const { isLoading, handleBlur, onSubmit, methods, showSuccessScreen } =
    useDownloadPDFForm({
      onClose,
      campaignSlug,
    });

  const FormInputsComp = (
    <div className={cls("form-wrapper")} id="download-pdf-modal">
      <div className={cls("heading")}>
        <h3 className={cls("title")}>Download our complete guide to {title}</h3>
        <p
          className={cls("description")}
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      </div>
      <DownloadPDFForm
        isLoading={isLoading}
        handleBlur={handleBlur}
        onSubmit={onSubmit}
        methods={methods}
      />
    </div>
  );

  const { mobile, email } = showSuccessScreen || {};

  const SuccessModalComp = (
    <DownloadPDFSuccess title={title} mobile={mobile} email={email} />
  );

  const component = showSuccessScreen ? SuccessModalComp : FormInputsComp;

  return (
    <ModalMotion
      className={cls("downloadPDFModal")}
      overlayClosable={true}
      onClose={onClose}
      width="500px"
      animateDirection={AnimateDirection.CENTER}
      borderRadius="10px"
      showClose
      iconTopPosition="20px"
      iconRightPosition="20px"
      // btnPos={btnPos}
      bodyPadding={"40px"}
    >
      {component}
    </ModalMotion>
  );
};

export default DownloadPDFModal;
